// extracted by mini-css-extract-plugin
export default {"background":"MainHeader_background__zQcp7","title":"MainHeader_title__gECEp"};